import { ActionList } from "../../components/ui";
import SortIcon from "../../components/ui/Sorting";
import { formatDateTime } from "../../helpers/formatDateTime";
import { COMMS_COLUMNS, getCommsAge, getSiteSelectionKey, resolveSiteIdentifierRegistryId } from "./commsSite";
import type { CommsSite, CommsSortColumn, CommsType, SortOrder } from "./commsSite";

interface Props {
    sites: CommsSite[];
    selectedSite: CommsSite | null;
    type: CommsType;
    column: CommsSortColumn;
    order: SortOrder;
    onSort: (column: CommsSortColumn) => void;
    onSelect: (id: number | string) => void;
    onView: (site: CommsSite) => void;
    onAddMessage: (site: CommsSite) => void;
    getMessage: (site: CommsSite) => string;
}

export function CommsSiteList({ sites, selectedSite, type, column, order, onSort, onSelect, onView, onAddMessage, getMessage }: Props) {
    return (
        <table className="table-responsive">
            <thead><tr>
                {COMMS_COLUMNS.map(item => <th key={item.key} onClick={() => onSort(item.key)} className="th--sortable"
                    aria-sort={column === item.key ? (order === "asc" ? "ascending" : "descending") : "none"}>
                    {item.label} <SortIcon sortOrder={column === item.key ? order : null} />
                </th>)}
                <th>Message</th><th>Actions</th>
            </tr></thead>
            <tbody>
                {!sites.length && <tr><td colSpan={6} className="table-responsive-nodata-text">No {type} sites found</td></tr>}
                {sites.map(site => {
                    const message = getMessage(site);
                    const selected = !!selectedSite && String(getSiteSelectionKey(site)) === String(getSiteSelectionKey(selectedSite));
                    return <tr key={getSiteSelectionKey(site)} onClick={() => onSelect(getSiteSelectionKey(site))}
                        className={`admin-request-row${selected ? " admin-request-row--selected" : ""}${message !== "—" && message !== "Unavailable" ? " message" : ""}`}>
                        <td>{site.siteName || "—"}, {site.region || "—"}</td>
                        <td>{formatDateTime(site.lastHeartbeatReceived)}</td>
                        <td>{getCommsAge(site)}</td>
                        <td>{site.offlineReasons?.join(", ") || "—"}</td>
                        <td>{message}</td>
                        <td><div onClick={event => event.stopPropagation()}>
                            <ActionList customActions={[
                                { label: "View", onClick: () => onView(site), className: "actions__item actions__item--view" },
                                ...(type === "offline" ? [{
                                    label: "Add Message", onClick: () => onAddMessage(site), className: "actions__item actions__item--edit",
                                    disabled: resolveSiteIdentifierRegistryId(site) === null,
                                }] : []),
                            ]} />
                        </div></td>
                    </tr>;
                })}
            </tbody>
        </table>
    );
}
